import { InfoBadgeStyled } from './styles/InfoBadgeStyled'
import { getAnalyticsDataAttrs } from '@ui/utils/analytics'
import { type Enum } from '@ui/utils/enums'

export const InfoBadgeTypes = {
  HIGH_PRIORITY: 'highPriority',
  LOW_PRIORITY: 'lowPriority',
  NEUTRAL: 'neutral',
} as const

export type InfoBadgeType = Enum<typeof InfoBadgeTypes>

export interface IInfoBadgeProps {
  /**
   * Unique identifier for analytics tracking.
   */
  analyticsId?: string
  type: InfoBadgeType
  text: string
  size?: 'small' | 'medium'
  'aria-label'?: string
}

export const InfoBadge = ({
  analyticsId,
  type,
  text,
  size = 'medium',
  'aria-label': ariaLabel,
}: IInfoBadgeProps) => {
  const analyticsProps = getAnalyticsDataAttrs(analyticsId)

  return (
    <InfoBadgeStyled
      type={type}
      size={size}
      aria-label={ariaLabel}
      {...analyticsProps}
    >
      <span>{text}</span>
    </InfoBadgeStyled>
  )
}
